var methods = "assert,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profileEnd,time,timeEnd,trace,warn".split(",");
var l = methods.length;

var fn = function fn() {};

var mockconsole = {};

while (l--) {
  mockconsole[methods[l]] = fn;
}

module.exports = mockconsole;